// extracted by mini-css-extract-plugin
export var legendIndicator = "_ag-1";
export var legendRight = "_ag-0";